<template slot="header">

  <div class="ti-table bc-gray" style="display: block;"
       v-bind:class="getSizeClasses()"
       v-b-tooltip.hover
       v-b-tooltip.nofade="getTooltipText"
       v-if="getIsAvailable">

       
    <div class="ti-headerrow d-flex"
         v-bind:class="{ ti_bg: isHeader, ti_bg_lite: !isHeader }">
      <div class="over flex-grow-1" style="white-space: unset; overflow: hidden; text-overflow: ellipsis;">
        <p v-bind:class="{ narrow_05: isNarrow, narrow_10: isVeryNarrow, localheading: isHeader }">
          <font-awesome-icon name="fa-thumbs-up" icon="star" v-if="hasStar"></font-awesome-icon>
          <span v-if="!fixContractualStandards">{{ showStandard ? getCustomizedStandardKpiName : ''}}{{ getKpiName }}</span>
          <span v-else>{{ kpi.KpiName }}</span>
        </p>
      </div>
      <button v-if="!disabled" class="kpi-question-button" @click="handleKpiQuestionsClick">
        <font-awesome-icon :icon="['far', 'list']" /> {{ $t('Webportal.DashboardBMW.Q&A') }}
      </button>
    </div>
<!--     
    <div class="ti-headerrow ti-cell grd"
         v-bind:class="{ ti_bg: isHeader, ti_bg_lite: !isHeader }">
      <div class="over">
        <p v-bind:class="{ narrow_05: isNarrow, narrow_10: isVeryNarrow, localheading: isHeader }">
          <font-awesome-icon name="fa-thumbs-up" icon="star" v-if="hasStar"></font-awesome-icon>
          {{ getKpiName }}
        </p>
      </div>
      <div class="tiny narrow_05" v-if="hasYtdValue(kpi)">
        YTD: {{ getYtdValue(kpi).Result }}
      </div>
    </div> -->

    <div class="ti-row" style="display: block;">
      <performanceitem  :invertArrow="invertArrow"
                        :isHeader="isHeader"
                        color="#035970"
                        :overallByWave="overallByWave"
                        :kpi="getEffectiveKpi"
                        :isLostLead="isLostLead"
                        :isStandalone="isStandalone"
                        :showPrewaves="showPrewaves"
                        :showInlineYtd="showInlineYtd"
                        :monochrome="monochrome"
                        :thresholds="thresholds"
                        :isBMWMoto="isBMWMoto" />
    </div>

    <div v-if="showNpsBar">
      <npsbar :kpi="kpi" />
    </div>
  </div>
  <div  v-else 
        class="ti-table bc-gray" 
        v-bind:class="getSizeClasses()" 
        style="opacity: 0.3; height:49px; margin-bottom: 2px;">
    <div class="ti-headerrow ti-cell"
         v-bind:class="{ ti_bg: isHeader, ti_bg_lite: !isHeader }">
    </div>
  </div>
</template>


<script>
  import EventBus from '@/services/EventBus.js'
  import npsbar from '@/components/Dashboard-bmw/NpsBar';
  import performanceitem from './PerformanceStarItem';
  import ytdMixin from '@/mixins/YearToDateMixin.js';
  import KpiItemMixin from '@/mixins/bmw/KpiItemMixin.js';

  export default {
    name: 'KpiStarItem',
    components: {
      performanceitem,
      npsbar
    },
    mixins: [ ytdMixin, KpiItemMixin ],
    data() {
      return {
        lockedText: undefined
      }
    },
    props:{
      disabled: { type: Boolean, default: false },
      isStandalone: { type: Boolean, required: false, default: false },
      fixContractualStandards: { type: Boolean, required: false },
      thresholds: { type: Array, required: true },
      showStandard: { type: Boolean, default: false }
    },
    methods: {
      handleKpiQuestionsClick(event) {
        EventBus.$emit('Modal-Kpi-Questions', { visible: true, kpi: this.kpi });
      }
    }
  };

</script>

<style scoped lang="scss">
  .localheading {
     font-size: 12pt;
  }
  .narrow {
    letter-spacing: -0.05em;
    width: 160px;
  }
  .over {
    height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  dic.ti-cell{
    align-content: center;
    align-content: space-around;
  }
  p{
    color: black;
    font-size: 9pt;
    font-weight: bold;
    font-stretch: extra-condensed;
    margin-bottom:0px;
    margin-left: 3px;
  }
  .tiny {
    color: black;
    font-size: 7pt;
    font-stretch: extra-condensed;
    margin-bottom:0px;
    border-left: 1px solid black;
    border-bottom: 1px solid black;
    top: -2px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
  }

</style>
